export const environment = {
  prod: false,
  apiBaseUrl: 'https://hq-fst.adad.ws/api',
};
